import Vue from 'vue'
import Vuex from 'vuex'
import Hits from './modules/Hits'
import Alerts from './modules/Alerts'
import Modals from './modules/Modals'
import UserApi from '@/services/Api/UserApi'
import SchoolApi from '@/services/Api/SchoolApi'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    Alerts,
    Modals,
    Hits
  },

  state: {
    loading: false,
    leagues: [],
    leagues_loading: false,
    ongoing_challenge: null,
    finished_challenge: null
  },

  mutations: {
    setLoading(state, loading) {
      state.loading = loading
    },

    setLeagues(state, leagues) {
      state.leagues = leagues
    },

    setLeaguesLoading(state, { loading }) {
      state.leagues_loading = loading
    },

    setOngoingChallenge(state, challenge) {
      state.ongoing_challenge = challenge
    },

    setFinishedChallenge(state, challenge) {
      state.finished_challenge = challenge
    }
  },

  actions: {
    getOngoingChallenge(context) {
      return UserApi.getOngoingChallenge()
        .then(challenge => context.commit('setOngoingChallenge', challenge))
    },

    getLeagues(context, { school_id }) {
      if (context.state.leagues_loading || context.state.leagues.length) {
        return
      }

      context.commit('setLeaguesLoading', {loading: true})

      return SchoolApi.getLeagues(school_id)
        .then(leagues => context.commit('setLeagues', leagues))
        .finally(() => context.commit('setLeaguesLoading', {loading: false}))
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js